<script setup lang="ts">
import { DgrSelectbox } from '@stockmarkteam/donguri-ui';

defineProps<{
  options: { label: string; value: string }[];
}>();

const model = defineModel<string>();
</script>
<template>
  <DgrSelectbox
    class="feed-date-selectbox"
    size="small"
    :options="options"
    v-model="model"
  />
</template>
<style scoped lang="scss">
.feed-date-selectbox {
  /* ここだけ見た目が特殊なので、
     :deep()でDgrSelectboxをカスタマイズすることを許容する */
  :deep(.c-selectBox) {
    border: none;
    font-weight: 700;
    padding: 0;
  }
  :deep(.c-selectBox__placeholder) {
    font-size: 16px; /* c-text-regular--xm 相当 */
  }
  :deep(.c-selectBox__arrow) {
    width: 24px !important; /* medium相当 */
    height: 24px !important; /* medium相当 */
  }
}
</style>
